import { DomainAPI } from "./setting";
export const getThumbnaiImage = (url) => {
  const thumbnailRegrex = "-thumbnail";
  const isThumbnail = url.includes(thumbnailRegrex);
  if (isThumbnail) return url;
  let cutUrl = url.split("/");
  let name = cutUrl[Math.max(cutUrl.length - 1, 0)];
  const thumbnailName = name.replace(".", thumbnailRegrex + ".");
  cutUrl.pop();
  cutUrl.push(thumbnailName);
  return cutUrl.join("/");
};

export const getDownloadUrl = (url) => {
  return `${DomainAPI}/external/api/public/download?url=${url}`;
};
